var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756383527667,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 51096,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.896 788.48l152.576-48.128c8.192-3.072 16.384-7.168 22.528-14.336l403.456-433.152c50.176-53.248 47.104-136.192-6.144-186.368-53.248-49.152-136.192-46.08-186.368 7.168L191.488 545.792c-6.144 7.168-10.24 15.36-12.288 23.552L142.336 727.04c-9.216 38.912 27.648 73.728 66.56 61.44z m423.936-640c29.696-31.744 80.896-33.792 112.64-4.096 31.744 29.696 33.792 80.896 4.096 112.64l-29.696 31.744-112.64-112.64 25.6-27.648zM229.376 581.632l343.04-367.616 112.64 112.64-338.944 363.52-152.576 48.128 35.84-156.672zM857.088 877.568H124.928c-14.336 0-25.6 11.264-25.6 25.6s11.264 25.6 25.6 25.6h732.16c14.336 0 25.6-11.264 25.6-25.6s-11.264-25.6-25.6-25.6z",
    fill: "currentColor",
    "p-id": 51097
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNote);
export default __webpack_public_path__ + "static/media/my-note.2519bc47.svg";
export { ForwardRef as ReactComponent };